<div class="">

    <h3 *ngIf="isAdminUser">Admin Token : {{authToken}} </h3>
    <h3 *ngIf="!isAdminUser">Company Token : {{authToken}} </h3>
    <button mat-raised-button color="primary" class="auth-form-btn mt-3 mt-lg-4 me-2" (click)="onGetToken()" style="max-width: 230px;"
    type="submit">
    {{"Get Token"|translate}}</button>
    <button mat-raised-button color="primary" class="auth-form-btn mt-3 mt-lg-4 ms-4" (click)="onEncryptCall()" style="max-width: 230px;"
    type="submit">
    {{"Encrypt API call"|translate}}</button>

    <div class="content">
      
    </div>
</div>
